<lu-switch
	[formControl]="formControl | fromAbstractToFormControl"
	[formlyAttributes]="field"
	[options]="field.templateOptions"
	[attr.hasValue]="formControl?.value !== null && formControl?.value !== undefined"
	(ngModelChange)="change($event)">
</lu-switch>
